<div [attr.id]="chartId" [ngClass]="class" class="chart-area" width="100%" [style.minHeight]="height+ 'px'"></div>